import { createSlice } from '@reduxjs/toolkit';
import { getFromSessionStorage } from '../storage';
import { IIndexable } from '../../interfaces';
import { getIconsData } from '../data-provider';

export interface IRootState{
    text: string,
    artTextSVG: string,
    loading: boolean,

    iconsData: IIndexable,
    category: string,
}

export const rootDefaults: IRootState = {
    text: 'HELLO',
    artTextSVG: '',
    loading: false,
    iconsData: getIconsData(),
    category: '',
};

// try get data from session storage
const savedData = getFromSessionStorage();

/**
 * initial state
 */
const initialState: IRootState = {
    loading: false,

    text: savedData?.text || rootDefaults.text,
    artTextSVG: '',

    iconsData: getIconsData(),
    category: savedData?.category || rootDefaults.category,
};

const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {

        main(state, action) {

            return  {
                ...state,
                ...action.payload,
            };
        },

        setCategory(state, action) {

            return {
                ...state,
                category: action.payload,
            };
        },
    }
});

export default rootSlice;